import { NOTIFICATION_POSITION, NOTIFICATION_STATUS } from 'core/domains';
import { put } from 'core/middlewares/utilities';
import { app } from 'core/use-cases';
import { v4 as uuidv4 } from 'uuid';

export function* showNotificationMinimumOrderAmount() {
  yield put(
    app.actions.showNotification({
      id: uuidv4(),
      message: 'O valor mínimo do pedido não foi atingido. Adicione mais itens para continuar.',
      position: NOTIFICATION_POSITION.TOP_RIGHT,
      showIcon: true,
      status: NOTIFICATION_STATUS.ERROR,
      timeout: 10_000,
    }),
  );
}
